import React from "react";
import PropTypes from "prop-types";
import { useGroupAccess } from "context/GroupAccessContext";

/**
 * Show `children` only when the signed-in user satisfies the named policy (see `config/groupPolicies.js`).
 *
 * @example
 * <GroupPolicyGate policy="contractManage">
 *   <MDButton>Edit contract</MDButton>
 * </GroupPolicyGate>
 *
 * @example OR of policies
 * <GroupPolicyGate policy={["contractManage", "managerOrAdmin"]}>...</GroupPolicyGate>
 */
function GroupPolicyGate({ policy, children, fallback }) {
  const { canAccessPolicy } = useGroupAccess();

  if (policy == null || policy === false) {
    return children;
  }

  const allowed = canAccessPolicy(policy);
  if (allowed) return children;
  if (fallback !== undefined && fallback !== null) return fallback;
  return null;
}

GroupPolicyGate.propTypes = {
  policy: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  children: PropTypes.node,
  fallback: PropTypes.node,
};

GroupPolicyGate.defaultProps = {
  children: null,
  fallback: null,
};

export default GroupPolicyGate;
